//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { DialogPlugin } from 'tdesign-vue';
import { SearchIcon } from 'tdesign-icons-vue';
import updateGroup from './components/updateGroup.vue';
import { mapGetters } from 'vuex';
export default {
  components: {
    SearchIcon,
    updateGroup,
  },
  data() {
    return {
      searchInfo: {
        keyword: '',
        appid: null,
      },
      appOptions: [],
      pagination: {
        total: 0,
        current: 1,
        pageSize: 10,
      },
      groupList: [],
      updateOrgsIsShow: false,
      isEdit: false,
      editId: null,
    };
  },
  computed: {
    ...mapGetters('user', ['getElementList']),
    jurisdiction() {
      const jurisdictionArray = [
        'userGroup_userPermissions_create',
        'userGroup_userPermissions_edit',
        'userGroup_userPermissions_delete',
      ];
      const jurisdictionObj = {};
      for (const item of jurisdictionArray) {
        jurisdictionObj[item] = this.getElementList.includes(item);
      }

      return jurisdictionObj;
    },
    columns() {
      return [
        {
          colKey: 'name',
          title: '名称',
          width: 200,
        },
        {
          colKey: 'code',
          title: 'Code',
          width: 200,
        },
        {
          colKey: 'create_by',
          title: '创建人',
          width: 150,
        },
        {
          colKey: 'create_time',
          title: '创建时间',
          width: 150,
        },
        {
          colKey: 'update_time',
          title: '更新时间',
          width: 150,
        },
        {
          colKey: 'description',
          title: '描述',
          width: 400,
        },
        {
          colKey: 'operation',
          title: '操作',
          width: 150,
          fixed: 'right',
        },
      ];
    },
  },
  async mounted() {
    await this.getAppOptions();
    this.getList();
  },
  methods: {
    async getList() {
      console.log('------getList------');
      const payload = {
        ...this.searchInfo,
        appid: this.searchInfo.appid ? this.searchInfo.appid : 0,
        page: this.pagination.current,
        page_size: this.pagination.pageSize,
      };
      const url = this.$api.getUserGroupList;
      const { data, total } = await this.$request({ url, data: payload });
      this.groupList = data;
      this.pagination.total = total;
    },
    async getAppOptions() {
      const res = await this.$request({
        url: this.$api.getAppList,
        data: { page_size: 9999 },
      });
      this.appOptions = res.data;
      if (this.appOptions.length > 0) {
        this.searchInfo.appid = this.appOptions[0].id;
        console.log('-------this.searchInfo.appid------', this.searchInfo.appid);
      }
    },
    resetForm() {
      this.searchInfo.keyword = '';
      this.current = 1;
      this.pageSize = 10;
      this.getList();
    },
    handleCreate() {
      this.updateOrgsIsShow = true;
      this.isEdit = false;
    },
    onPageChange(pageInfo, newDataSource) {
      console.log('pageInfo', pageInfo);
      this.pagination = pageInfo;
      console.log('newDataSource', newDataSource);
      this.getList();
    },
    handleEdit({ id }) {
      this.updateOrgsIsShow = true;
      this.isEdit = true;
      this.editId = id;
    },
    async handleDelete(row) {
      const confirmDia = DialogPlugin.confirm({
        header: `确定要删除（${row.name}）吗`,
        body: `删除后，（${row.name}）将消失`,
        confirmBtn: '确定',
        theme: 'warning',
        cancelBtn: '取消',
        onConfirm: async () => {
          console.log(row);
          try {
            const url = this.$api.deleteUserGroup;
            const data = { id: row.id };
            await this.$request({ url, data });
            this.$message.success('删除成功');
            this.getList();
            confirmDia.hide();
          } catch (e) {
            confirmDia.hide();
          }
        },
        onClose: () => {
          confirmDia.hide();
        },
      });
    },
    handleRefresh() {
      this.updateOrgsIsShow = false;
      this.getList();
    },
  },
};
